import { SeasonID } from '@shared/types';
import { Cls, Emojis } from 'app/constants';
import { getDbVersion, MY_NFL_STATS_DB } from 'lib/idb/IndexDb';
import { GameWeek } from 'types';
import { IWorkerIDBLoaderRequestMessage } from 'types/IndexDb.types';

export const getIndexDBLoaderWebWorker = (caller?: string) => {
  const webWorker = new Worker(new URL('webworkers/webworkerIndexDbDataLoader.ts', import.meta.url));
  const msg = `for %c ${caller || 'unknown caller'} %c`;
  console.log(`${Emojis.hammers} %c CREATED %c web worker ${msg}`, Cls.Act, '', Cls.Bur, '');
  return webWorker;
};
export const getLoadStoreRequestMessage = (
  storeName: string,
  year: SeasonID = '2025',
  shouldFetch: boolean,
  weekID?: GameWeek,
  modelVersion?: string
) => {
  const workerRequestMessage: IWorkerIDBLoaderRequestMessage = {
    request: { storeName, idbName: MY_NFL_STATS_DB, idbVersion: getDbVersion() },
    type: 'get-store-data',
    payload: { year, weekID, shouldFetch, modelVersion },
  };
  return workerRequestMessage;
};
